export default "__VITE_ASSET__D5H4utHz__"